import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportPointMutationPageRoutingModule } from './report-point-mutation-routing.module';

import { ReportPointMutationPage } from './report-point-mutation.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportPointMutationPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [ReportPointMutationPage]
})
export class ReportPointMutationPageModule {}
